export enum Level {
    BEGINNER,
    ADVANCED
}